// services/user/UserCatalogService.js
import API from "../../api/apiUser";

const UserCatalogService = {
    downloadCatalog() {
        return API.get("/user/catalog/download", {
            responseType: 'blob'
        });
    },
};

export default UserCatalogService;
